import { Portfolio, PortfolioKeyLimitAlert, RiskDesk } from "src/@type/risk-management/types";
import { PortfolioDTO, PortfolioKeyLimitAlertDTO, RiskDeskDTO } from "./DTO";

export const mapperRiskDeskModelToDTO = (r: RiskDesk): Omit<RiskDeskDTO, 'R'> => ({
    i: r.id,
    n: r.name,
	a: r.Active,
	e: r.ExternalCode1,
	g: r.GroupDeskID,
    r: r.SendInAllDeskPositionReport,
    l: r.SendDeskPositionReportDepthLevel
});

export const mapperPortfolioKeyLimitAlertToDTO = (l: PortfolioKeyLimitAlert): PortfolioKeyLimitAlertDTO => ({
    i: l.id,
	k: l.key,
	p: l.per,
    c: l.flagColor,
    n: l.bellNote
});

export const mapperPortfolioToDTO = (p: Portfolio): Omit<PortfolioDTO, 'A'> => ({
    a: p.id,
    b: p.DeskID,
    c: p.Name,
    d: p.Description,
    e: p.TakeInGlobalPosition,
    f: p.TakeInDeskPosition,
    g: p.VaRLimit,
    h: p.VolumeLimit,
    i: p.NominalLimit,
    j: p.DrawdownLimit,
    k: p.StopLossLimit,
    l: p.GammaLimit,
    m: p.VegaLimit,
    n: p.YtdPnLLimit
});